import { render } from "./IconAlertWarning.vue?vue&type=template&id=5332ea9f"
import script from "./IconAlertWarning.vue?vue&type=script&lang=js"
export * from "./IconAlertWarning.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__